import { useCallback } from 'react';
import { prop } from 'ramda';
import { IGamesFeed } from 'js/hooks/games/types';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { useAppSelector, useDeviceSelector, useGameConfigurationSelector } from 'js/store/hooks';
import { workerService } from 'js/services/worker.service';
import { TDeviceFormFactor } from 'js/hooks/device/store/types';

export const useGetGamesFeed = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const formFactor = useDeviceSelector(prop('formFactor'));
    const requestStamp = useAppSelector(prop('requestStamp'));
    const gamesFeeds = useGameConfigurationSelector(prop('gamesFeeds'));

    return useCallback(async (feedName: string, disableCache?: boolean): Promise<IGamesFeed> => {
        if (gamesFeeds[feedName] && !disableCache) {
            return gamesFeeds[feedName];
        }

        const gamesFeedURL = getCMSResourceURL(`/initialResources/gamesFeeds/${encodeURIComponent(feedName)}`, { t: requestStamp });

        return await workerService
            .request<{
                formFactor: TDeviceFormFactor;
                gamesFeedURL: string;
            }, IGamesFeed>('gamesFeed', {
                gamesFeedURL,
                formFactor
            });
    }, [requestStamp, getCMSResourceURL, formFactor, gamesFeeds]);
};
